var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"slide"},[_c('typography',{staticClass:"slide__days",attrs:{"variant":"accent","text":_vm.daysLeft}}),_vm._v(" "),_c('typography',{staticClass:"slide__label",attrs:{"variant":"body-3","text":_vm.label}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }